import CustomState from '@rio-cloud/rio-uikit/CustomState';
import { FormattedMessage } from 'react-intl';

const HistoryNotAvailableErrorState = () => {
    return (
        <CustomState
            headline={<FormattedMessage id="intl-msg:batteryService.error.historyNotAvailable" />}
            message={<FormattedMessage id="intl-msg:batteryService.error.historyNotAvailableMessage" />}
            icons={[
                {
                    name: 'rioglyph rioglyph-pylon',
                },
            ]}
        />
    );
};

export default HistoryNotAvailableErrorState;
